import { css } from "styled-components";

export const primaryButtonStyles = (
  $type: "solid" | "outline" | "text",
  $dark?: boolean
) => {
  if ($type === "solid") {
    return css`
      background: var(--pri-blue-4);
      border: 0.1rem solid transparent;
      & > p {
        color: var(--text-gray-normal);
      }
      & > svg path {
        stroke: var(--text-gray-normal);
      }
      &:hover {
        background: rgba(33, 139, 255, 0.56);
      }
      &:active {
        background: ${$dark
          ? `linear-gradient(
            0deg, 
            rgba(254, 254, 254, 0.48) 0%, 
            rgba(254, 254, 254, 0.48) 100%
          ), 
          var(--pri-blue-4, #0969DA)`
          : `linear-gradient(
            0deg,
            rgba(7, 7, 7, 0.48) 0%,
            rgba(7, 7, 7, 0.48) 100%
          ),
          var(--pri-blue-4, #218bff)`};
      }
      &.selected {
        background: var(--pri-blue-7);
      }
      &:disabled {
        background: var(--bg-gray-2);
        & > p {
          color: var(--text-gray-0);
        }
        & > svg path {
          stroke: var(--text-gray-0);
        }
      }
    `;
  }

  if ($type === "outline") {
    return css`
      background: transparent;
      border: 1px solid var(--pri-blue-4);
      & > p {
        color: var(--pri-blue-4);
      }
      & > svg path {
        stroke: var(--pri-blue-4);
      }
      &:hover {
        background: ${$dark
          ? "rgba(203, 203, 207, 0.24)"
          : "rgba(139, 139, 147, 0.24)"};
      }
      &:active {
        background: ${$dark
          ? "rgba(254, 254, 254, 0.32)"
          : "rgba(7, 7, 7, 0.32)"};
      }
      &.selected {
        background: var(--pri-blue-1);
        border: 1px solid var(--pri-blue-7);
        & > p {
          color: var(--pri-blue-7);
        }
        & > svg path {
          stroke: var(--pri-blue-7);
        }
      }
      &:disabled {
        background: transparent;
        border: 0.1rem solid var(--bg-gray-2);
        & > p {
          color: var(--bg-gray-2);
        }
        & > svg path {
          stroke: var(--bg-gray-2);
        }
      }
    `;
  }

  if ($type === "text") {
    return css`
      background: transparent;
      border: 0.1rem solid transparent;
      & > p {
        color: var(--pri-blue-4);
      }
      & > svg path {
        stroke: var(--pri-blue-4);
      }
      &:hover {
        background: ${$dark
          ? "rgba(203, 203, 207, 0.24)"
          : "rgba(139, 139, 147, 0.24)"};
      }
      &:active {
        background: ${$dark
          ? "rgba(254, 254, 254, 0.32)"
          : "rgba(7, 7, 7, 0.32)"};
      }
      &.selected {
        background: var(--pri-blue-1);
        & > p {
          color: var(--pri-blue-7);
        }
        & > svg path {
          stroke: var(--pri-blue-7);
        }
      }
      &:disabled {
        background: transparent;
        & > p {
          color: var(--bg-gray-2);
        }
        & > svg path {
          stroke: var(--bg-gray-2);
        }
      }
    `;
  }
};
